/**
 * Escapes special regex characters in a string to make it safe for use in a RegExp constructor
 * @param string - The string to escape
 * @returns The escaped string
 */
export function escapeRegExp(string: string): string {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
